import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FileReference} from '../../class/file-reference';
import {NbMenuItem, NbMenuService} from '@nebular/theme';
import {ApiService} from '../../service/api.service';
import {filter} from 'rxjs/operators';

@Component({
  selector: 'app-attachment',
  templateUrl: './attachment.component.html',
  styleUrls: ['./attachment.component.css']
})
export class AttachmentComponent implements OnInit {

  @Input()
  file: FileReference;

  @Output()
  onFileDownload = new EventEmitter<FileReference>();

  @Output()
  onFileDelete = new EventEmitter<FileReference>();

  nbMenuItems: NbMenuItem[] = [
    {title: 'Scarica', icon: ''},
    {title: 'Elimina', icon: ''},
  ];

  constructor(private nbMenuService: NbMenuService) {
  }

  ngOnInit(): void {
    this.nbMenuService.onItemClick()
      .pipe(
        filter(({tag}) => tag === 'attachments-menu-' + this.file.name),
      )
      .subscribe(value => {
        if (value) {
          if (value.item.title === 'Scarica') {
            this.onFileDownload.emit(this.file);
          } else {
            this.onFileDelete.emit(this.file);
          }
        }
      });
  }
}
